import { DatePicker } from '@material-ui/pickers'
import LeftIcon from 'mdi-react/ChevronLeftIcon'
import RightIcon from 'mdi-react/ChevronRightIcon'
import { useState, useEffect } from 'react'
import { getCurrentLanguage } from '../../../translations/i18n'
import { formatMoment } from '../../../utils/dates'
// import { formatDateToUtc } from '../../../utils/dates'

const cancelLabel = {
  en: 'cancel',
  fi: 'peruuta'
}

interface ReduxDatePickerProps {
  input: { value: string | Date | undefined; onChange: any; onBlur: any }
  label: string
  invalidLabel: string
  meta: any
  [key: string]: any
}

/** Used to connect redux forms with mui/pickers date picker */
const ReduxDatePicker = ({
  input: { onChange, value, onBlur },
  label,
  invalidLabel,
  meta: { touched, invalid, error },
  ...custom
}: ReduxDatePickerProps) => {
  const [locale, setLocale] = useState<string>(getCurrentLanguage())

  useEffect(() => {
    const currentLocale = getCurrentLanguage()
    setLocale(currentLocale)
  }, [locale, setLocale])
  return (
    <DatePicker
      label={label}
      invalidLabel={invalidLabel}
      cancelLabel={cancelLabel[locale]}
      format='DD.MM.YYYY'
      leftArrowIcon={<LeftIcon />}
      rightArrowIcon={<RightIcon />}
      helperText={invalid && touched ? error : undefined}
      error={invalid && touched}
      value={value || null}
      onClose={() => onBlur()}
      onChange={(momentValue) =>
        onChange(formatMoment(momentValue, 'YYYY-MM-DD'))
      }
      {...custom}
    />
  )
}

export default ReduxDatePicker
